import React, { type FC } from "react"

import { TitleSlideTemplate } from "../../SlideTemplates/TitleSlide"

export const ThankYou: FC = () => <TitleSlideTemplate heading="Thank you!" />
